<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer003">
<p class="pl-fl-roman"><b>Carla Kelly</b> started writing Regency romances because of her interest in the Napoleonic Wars, and she enjoys writing about warfare at sea and the ordinary people of the British Isles rather than lords and ladies. In her spare time, she reads British crime fiction and history—particularly books about the American Indian Wars. Carla lives in Utah and is a former park ranger and double RITA® Award and Spur Award winner. She has five children and four grandchildren.</p>
<p class="pl-fl-roman"><b>Louise Allen </b>loves immersing herself in history. She finds landscapes and places evoke the past powerfully. Venice, Burgundy and the Greek islands are favorite destinations. Louise lives on the Norfolk coast and spends her spare time gardening, researching family history or traveling in search of inspiration. Visit her at <a href="http://www.louiseallenregency.co.uk" target="_blank">louiseallenregency.co.uk</a>, <a href="https://twitter.com/LouiseRegency?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor" target="_blank">@louiseregency</a> and <a href="http://www.janeaustenslondon.com" target="_blank">janeaustenslondon.com</a>.</p>
<p class="pl-fl-roman"><b>Laurie Benson </b>is an award-winning Regency romance author whose book <i>An Unexpected Countess</i> featured Harlequin’s 2017 Hero of the Year, as voted by readers. She began her writing career as an advertising copywriter. When she isn’t at her laptop avoiding laundry, Laurie can be found browsing antiques shops and going on long hikes with her husband and two sons. Learn more about Laurie by visiting her website at <a href="http://lauriebenson.net" target="_blank">lauriebenson.net</a>. You can also find her on Twitter and Facebook.</p>
<p class="pl-center-nsa">Join Harlequin My Rewards today and earn a FREE ebook!</p>
<p class="pl-center-nsa">Click here to Join Harlequin My Rewards</p>
<p class="pl-center"><a href="http://www.harlequin.com/myrewards.html?mt=loyalty&amp;cmpid=EBOOBPBPA201602010002" target="_blank">http://www.harlequin.com/myrewards.html?mt=loyalty&amp;cmpid=EBOOBPBPA201602010002</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// About_the_Authors.vue?7dc8cdd6